<h1 mat-dialog-title class="text-xl font-semibold text-gray-800 mb-4">
  Ingrese su información de contacto para habilitarle un código de acceso
</h1>
<mat-dialog-content class="p-6">
  <div class="w-full">
      <form [formGroup]="form!" class="space-y-6">
        <div class="w-full">
          <mat-form-field class="w-full">
            <mat-label class="text-gray-700">Nombres</mat-label>
            <input
              type="text"
              matInput
              title="Nombres"
              maxlength="100"
              formControlName="name"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            @if (form!.controls['name'].touched && form!.controls['name'].hasError('required')) {
              <mat-error class="text-red-500 text-sm mt-1">Debe ingresar su nombre</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="w-full">
          <mat-form-field class="w-full">
            <mat-label class="text-gray-700">Apellidos</mat-label>
            <input
              type="text"
              matInput
              title="Apellidos"
              maxlength="100"
              formControlName="lastname"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            @if (form!.controls['lastname'].touched && form!.controls['lastname'].hasError('required')) {
              <mat-error class="text-red-500 text-sm mt-1">Debe ingresar su apellido</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="w-full">
          <mat-form-field class="w-full">
            <mat-label class="text-gray-700">Email</mat-label>
            <input
              type="email"
              matInput
              title="Email"
              maxlength="100"
              formControlName="email"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            @if (form!.controls['email'].touched && (form!.controls['email'].hasError('required') || form!.controls['email'].hasError('email'))) {
              <mat-error class="text-red-500 text-sm mt-1">Debe ingresar un email válido</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="w-full">
          <app-phone-input
            placeholder="Celular +..."
            formControlName="phone"
          ></app-phone-input>

          @if (form!.controls['phone'].touched && (form!.controls['phone'].hasError('required') || form!.controls['phone'].hasError('invalidPhone'))) {
          <div class="w-full">
            @if (form!.controls['phone'].touched && form!.controls['phone'].hasError('required')) {
              <span class="text-red-500 text-sm mt-1">Debe ingresar un celular</span>
            }
            @if (form!.controls['phone'].touched && form!.controls['phone'].hasError('invalidPhone') && !form!.controls['phone'].hasError('required')) {
              <span class="text-red-500 text-sm mt-1">El número de teléfono no es válido</span>
            }
          </div>
          }
        </div>
      </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-end space-x-4 p-6 bg-gray-50 border-t border-gray-200">
  <div class="flex flex-col space-y-2">
    <app-action-loader>
      <button
        mat-raised-button
        color="accent"
        (click)="onCancel()"
        tabindex="0"
        [disabled]="saveRequest.isRunning()"
        class="px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
      >
        Cancelar
      </button>
  </app-action-loader>
  </div>
  <app-action-loader #saveRequest>
      <button
        mat-raised-button
        color="primary"
        (click)="onSave()"
        tabindex="0"
        type="submit"
        [disabled]="!form!.valid || saveRequest.isRunning()"
        class="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
      >
        Solicitar
      </button>
  </app-action-loader>
</mat-dialog-actions>
